import PaypalPaymentInfoContainer from './PaypalPaymentInfoContainer';

export default PaypalPaymentInfoContainer;
